import { useGetApprovedUsersQuery, useGetPendingUsersQuery } from '../../api/user.js';
import AuthLayout from '../../components/layout/AuthLayout.jsx';
import ThreeDotsLoader from '../../components/misc/ThreeDotsLoader.jsx';
import UserListItem from '../../components/misc/users/UserListItem.jsx';

const UserManagement = () => {
    const { data: pendingUsers, error: pendingUsersError, isLoading: pendingUsersLoading } = useGetPendingUsersQuery();
    const {
        data: approvedUsers,
        error: approvedUsersError,
        isLoading: approvedUsersLoading
    } = useGetApprovedUsersQuery();

    const pendingUserList = pendingUsers?.response?.users || [];
    const approvedUserList = approvedUsers?.response?.users || [];

    return (
        <AuthLayout title='User Management' backRoute='/dashboard'>
            <div className='flex flex-col max-w-3xl w-full mx-auto mt-4'>
                <div className='text-xl font-bold text-theme1-title2 mb-4 px-8'>Pending Request List</div>
                {pendingUsersLoading ? (
                    <ThreeDotsLoader />
                ) : pendingUsersError ? (
                    <div className='text-theme1-primary text-base'>Error loading pending users</div>
                ) : pendingUserList.length > 0 ? (
                    pendingUserList.map((user, index) => (
                        <UserListItem
                            key={user.id}
                            type='pending'
                            user={user}
                            isLast={index === pendingUserList.length - 1}
                        />
                    ))
                ) : (
                    <div className='text-theme1-primary text-base px-8 -mt-2 mb-2'>No pending users found</div>
                )}
            </div>

            <div className='flex flex-col max-w-3xl w-full mx-auto mt-4'>
                <div className='text-xl font-bold text-theme1-title2 mb-4 px-8'>Approved Users</div>
                {approvedUsersLoading ? (
                    <ThreeDotsLoader />
                ) : approvedUsersError ? (
                    <div className='text-theme1-primary text-base'>Error loading approved users</div>
                ) : approvedUserList.length > 0 ? (
                    approvedUserList.map((user, index) => (
                        <UserListItem
                            key={user.id}
                            type='approved'
                            user={user}
                            isLast={index === approvedUserList.length - 1}
                        />
                    ))
                ) : (
                    <div className='text-theme1-primary text-base px-8'>No approved users found</div>
                )}
            </div>
        </AuthLayout>
    );
};

export default UserManagement;
